import { Component, Input, OnInit } from '@angular/core';
import { Node } from '../model/node.model';
import { NodesService } from '../service/nodes.service';
import { NodeHistory } from '../model/node-history.model';
import { MsgModel } from '../../common-components/msg/model/msg.model';

@Component({
    selector: 'app-node-header',
    templateUrl: './node-header.component.html',
    styleUrl: './node-header.component.scss'
})
export class NodeHeaderComponent implements OnInit {
    @Input() node: Node;
    @Input() header: string = '';

    showHistory: boolean = false;
    nodeHistories: NodeHistory[];

    currentStatus: string = '';
    preivousStatus: string = '';

    msg: MsgModel;

    constructor(private nodesService: NodesService) {}

    ngOnInit(): void {
        this.getHistories();
    }

    getHistories() {
        //console.log("node id:", this.nodeId)
        this.nodesService.getHistories(this.node.ID).subscribe({
            next: (res) => {
                if (res.histories) {
                    this.nodeHistories = res.histories;

                    this.getStatusBanner();
                }
            },
            error: (err) => {
                this.msg = { SUCCESS: false, MSG: 'Error retrieving Node Histories.' };
            },
            complete: () => {
                //do nothing
            }
        });
    }

    getStatusBanner() {
        const lastestNodeHistory = this.nodeHistories[this.nodeHistories.length - 1];

        if (lastestNodeHistory.WORKFLOW_STATE_TYPES1.NAME === 'Completion State') {
            this.currentStatus = lastestNodeHistory.WORKFLOW_STATE_TYPES1.DESCRIPTION;
            this.preivousStatus = lastestNodeHistory.WORKFLOW_STATE_TYPES.DESCRIPTION;
        } else {
            this.currentStatus = this.node.WORKFLOW_STATE_TYPES.DESCRIPTION!;
        }
    }
}
